export var ScatterPlotChartSize;
(function (ScatterPlotChartSize) {
    ScatterPlotChartSize["basic_650"] = "basic_650";
    ScatterPlotChartSize["basic_850"] = "basic_850";
    ScatterPlotChartSize["basic_1200"] = "basic_1200";
    ScatterPlotChartSize["basic_2000"] = "basic_2000";
})(ScatterPlotChartSize || (ScatterPlotChartSize = {}));
// ScatterPlotParams constants
export var ScatterPlotChartType;
(function (ScatterPlotChartType) {
    ScatterPlotChartType["interactive"] = "interactive";
    ScatterPlotChartType["presentation"] = "presentation";
})(ScatterPlotChartType || (ScatterPlotChartType = {}));
export var ScatterPlotPlotType;
(function (ScatterPlotPlotType) {
    ScatterPlotPlotType["pointInTime"] = "point_in_time";
    ScatterPlotPlotType["timeseries"] = "timeseries";
})(ScatterPlotPlotType || (ScatterPlotPlotType = {}));
export var ScatterPlotSeriesType;
(function (ScatterPlotSeriesType) {
    ScatterPlotSeriesType["security"] = "security";
    ScatterPlotSeriesType["securityList"] = "security_list";
    ScatterPlotSeriesType["efficientFrontier"] = "efficient_frontier";
})(ScatterPlotSeriesType || (ScatterPlotSeriesType = {}));
// From '#point sizes/shapes' in ycharts/constants.py
export var ScatterPlotDataShapeSize;
(function (ScatterPlotDataShapeSize) {
    ScatterPlotDataShapeSize["small"] = "small";
    ScatterPlotDataShapeSize["medium"] = "medium";
    ScatterPlotDataShapeSize["large"] = "large";
})(ScatterPlotDataShapeSize || (ScatterPlotDataShapeSize = {}));
export var ScatterPlotDataShape;
(function (ScatterPlotDataShape) {
    ScatterPlotDataShape["circle"] = "circle";
    ScatterPlotDataShape["cross"] = "cross";
    ScatterPlotDataShape["diamond"] = "diamond";
    ScatterPlotDataShape["triangle"] = "triangle";
})(ScatterPlotDataShape || (ScatterPlotDataShape = {}));
export var ScatterPlotLabelPlacement;
(function (ScatterPlotLabelPlacement) {
    ScatterPlotLabelPlacement["default"] = "";
    ScatterPlotLabelPlacement["top_left"] = "label_placement_top_left";
    ScatterPlotLabelPlacement["left"] = "label_placement_left";
    ScatterPlotLabelPlacement["bottom_left"] = "label_placement_bottom_left";
    ScatterPlotLabelPlacement["top_right"] = "label_placement_top_right";
    ScatterPlotLabelPlacement["right"] = "label_placement_right";
    ScatterPlotLabelPlacement["bottom_right"] = "label_placement_bottom_right";
})(ScatterPlotLabelPlacement || (ScatterPlotLabelPlacement = {}));
// This is used on the front end only, the backend only cares about startDate and endDate
export var ScatterPlotDateRangeType;
(function (ScatterPlotDateRangeType) {
    ScatterPlotDateRangeType["date"] = "date";
    ScatterPlotDateRangeType["year"] = "year";
})(ScatterPlotDateRangeType || (ScatterPlotDateRangeType = {}));
export var ScatterPlotChartOptionValue;
(function (ScatterPlotChartOptionValue) {
    // Interactive
    ScatterPlotChartOptionValue["displayAllTickers"] = "displayAllTickers";
    ScatterPlotChartOptionValue["displayAllXYData"] = "displayAllXYData";
    ScatterPlotChartOptionValue["displayAllCurrencyCodes"] = "displayAllCurrencyCodes";
    ScatterPlotChartOptionValue["displayAllDates"] = "displayAllDates";
    ScatterPlotChartOptionValue["displayAllNames"] = "displayAllNames";
    ScatterPlotChartOptionValue["displayBestFitLine"] = "displayBestFitLine";
    ScatterPlotChartOptionValue["displayLegend"] = "displayLegend";
    ScatterPlotChartOptionValue["displayCurrencyCodeInLegend"] = "displayCurrencyCodeInLegend";
    ScatterPlotChartOptionValue["displayXYDataInLegend"] = "displayXYDataInLegend";
    ScatterPlotChartOptionValue["displayColorRange"] = "displayColorRange";
    ScatterPlotChartOptionValue["nameInLegend"] = "nameInLegend";
    ScatterPlotChartOptionValue["useCustomColors"] = "useCustomColors";
    // Annotations
    ScatterPlotChartOptionValue["plotLines"] = "plotLines";
    // Presentation
    ScatterPlotChartOptionValue["displayLegendOnChart"] = "displayLegendOnChart";
    ScatterPlotChartOptionValue["performanceDisclosure"] = "performanceDisclosure";
})(ScatterPlotChartOptionValue || (ScatterPlotChartOptionValue = {}));
export var ScatterPlotPresentationOptionValue;
(function (ScatterPlotPresentationOptionValue) {
    ScatterPlotPresentationOptionValue["title"] = "title";
    ScatterPlotPresentationOptionValue["note"] = "note";
    ScatterPlotPresentationOptionValue["size"] = "size";
    ScatterPlotPresentationOptionValue["legendOrientation"] = "legendOrientation";
})(ScatterPlotPresentationOptionValue || (ScatterPlotPresentationOptionValue = {}));
export var ScatterPlotPlotOptionValue;
(function (ScatterPlotPlotOptionValue) {
    ScatterPlotPlotOptionValue["color"] = "color";
    ScatterPlotPlotOptionValue["shape"] = "shape";
    ScatterPlotPlotOptionValue["displayXYData"] = "display_x_y_data";
    ScatterPlotPlotOptionValue["displayCurrencyCode"] = "display_currency_code";
    ScatterPlotPlotOptionValue["displayDates"] = "display_dates";
    ScatterPlotPlotOptionValue["includeInLegend"] = "include_in_legend";
    ScatterPlotPlotOptionValue["displayName"] = "display_name";
    ScatterPlotPlotOptionValue["displayTicker"] = "display_ticker";
    ScatterPlotPlotOptionValue["labelPlacement"] = "label_placement";
    ScatterPlotPlotOptionValue["size"] = "size";
    ScatterPlotPlotOptionValue["name"] = "name";
    ScatterPlotPlotOptionValue["includeThroughLine"] = "include_through_line";
    ScatterPlotPlotOptionValue["seriesLabelLocation"] = "series_label_location";
    ScatterPlotPlotOptionValue["canSelectPoint"] = "can_select_point";
    ScatterPlotPlotOptionValue["series_class"] = "series_class";
    ScatterPlotPlotOptionValue["lineColor"] = "line_color";
    ScatterPlotPlotOptionValue["lineWidth"] = "line_width";
    ScatterPlotPlotOptionValue["selectedColor"] = "selected_color";
    ScatterPlotPlotOptionValue["parentSecurityListName"] = "parent_security_list_name";
    ScatterPlotPlotOptionValue["performanceDisclosure"] = "performance_disclosure";
})(ScatterPlotPlotOptionValue || (ScatterPlotPlotOptionValue = {}));
export var ScatterPlotStatus;
(function (ScatterPlotStatus) {
    ScatterPlotStatus["ok"] = "ok";
    ScatterPlotStatus["error"] = "error";
    ScatterPlotStatus["loading"] = "loading";
    ScatterPlotStatus["noData"] = "noData";
    ScatterPlotStatus["allSeriesExceedDataLimit"] = "allSeriesExceedDataLimit";
    ScatterPlotStatus["getStarted"] = "getStarted";
})(ScatterPlotStatus || (ScatterPlotStatus = {}));
export var ScatterPlotAxisType;
(function (ScatterPlotAxisType) {
    ScatterPlotAxisType["x"] = "x";
    ScatterPlotAxisType["y"] = "y";
})(ScatterPlotAxisType || (ScatterPlotAxisType = {}));
export var ScatterPlotPresentationValidModes;
(function (ScatterPlotPresentationValidModes) {
    ScatterPlotPresentationValidModes["imageCode"] = "image_code";
    ScatterPlotPresentationValidModes["imageCodeTemplate"] = "image_code_template";
    ScatterPlotPresentationValidModes["imageContents"] = "image_contents";
    ScatterPlotPresentationValidModes["imageDownload"] = "image_download";
    ScatterPlotPresentationValidModes["imageAttachment"] = "image_attachment";
    ScatterPlotPresentationValidModes["imageUrl"] = "image_url";
})(ScatterPlotPresentationValidModes || (ScatterPlotPresentationValidModes = {}));
export var ScatterPlotLookbackType;
(function (ScatterPlotLookbackType) {
    ScatterPlotLookbackType["oneYear"] = "1 Year";
    ScatterPlotLookbackType["threeYears"] = "3 Years";
    ScatterPlotLookbackType["fiveYears"] = "5 Years";
    ScatterPlotLookbackType["tenYears"] = "10 Years";
    ScatterPlotLookbackType["custom"] = "Custom";
})(ScatterPlotLookbackType || (ScatterPlotLookbackType = {}));
export var ScatterPlotLookbackOptionXValues;
(function (ScatterPlotLookbackOptionXValues) {
    ScatterPlotLookbackOptionXValues["oneYear"] = "monthly_standard_deviation_annualized_1y";
    ScatterPlotLookbackOptionXValues["threeYears"] = "monthly_standard_deviation_annualized_3y";
    ScatterPlotLookbackOptionXValues["fiveYears"] = "monthly_standard_deviation_annualized_5y";
    ScatterPlotLookbackOptionXValues["tenYears"] = "monthly_standard_deviation_annualized_10y";
})(ScatterPlotLookbackOptionXValues || (ScatterPlotLookbackOptionXValues = {}));
export var ScatterPlotLookbackOptionYValues;
(function (ScatterPlotLookbackOptionYValues) {
    ScatterPlotLookbackOptionYValues["oneYear"] = "annualized_one_year_total_return";
    ScatterPlotLookbackOptionYValues["threeYears"] = "annualized_three_year_total_return";
    ScatterPlotLookbackOptionYValues["fiveYears"] = "annualized_five_year_total_return";
    ScatterPlotLookbackOptionYValues["tenYears"] = "annualized_ten_year_total_return";
})(ScatterPlotLookbackOptionYValues || (ScatterPlotLookbackOptionYValues = {}));
